// extracted by mini-css-extract-plugin
export default {"aiSuggestionWrapper":"aiSuggestionWrapper_aiSuggestionWrapper__h9LAS","extraLoading":"aiSuggestionWrapper_extraLoading__iMfJj","pulseGlow":"aiSuggestionWrapper_pulseGlow__Faf67"};